import React from 'react'
import cx from 'classnames'

import { IconName } from 'components/_new/ui/Icon/Icon'
import ButtonBase, { ButtonBaseProps } from '../ButtonBase/ButtonBase'
import ButtonContent, { ButtonContentProps } from '../ButtonContent/ButtonContent'
import ButtonIcon from './ButtonIcon/ButtonIcon'


import s from './ButtonWithIcons.scss'


export type ButtonWithIconProps = ButtonBaseProps & ButtonContentProps & {
  leftIcon?: IconName
  rightIcon?: IconName
  centering?: boolean
}

const ButtonWithIcons: React.FunctionComponent<ButtonWithIconProps> = (props) => {
  const {
    children, title, size, loading, loadingMessage, fullWidth, fullWidthOnMobile, centering, noPadding,
    leftIcon, rightIcon,
    ...rest
  } = props

  return (
    <ButtonBase size={size} fullWidth={fullWidth} fullWidthOnMobile={fullWidthOnMobile} {...rest}>
      <div className={cx(s.content, { [s.center]: centering })}>
        <ButtonIcon
          icon={leftIcon}
          compact={!fullWidth}
          compactMobile={!fullWidthOnMobile}
        />
        <ButtonContent {...{ children, title, size, loading, loadingMessage, centering, noPadding }} />
        <ButtonIcon
          icon={rightIcon}
          compact={!fullWidth}
          compactMobile={!fullWidthOnMobile}
        />
      </div>
    </ButtonBase>
  )
}


export default ButtonWithIcons
